import axios from 'axios';
import _ from 'lodash';
import Constants from '../constants';
import { IParticipationCountsVm } from '../models';

export function getAudienceQuery(surveyId: number, audienceId: number) {
	// show all results when dimension any dimension is selected by seting the limit to be arbitrarily high
	const url = Constants.AUDIENCE_API_BASE_URL.replace('{surveyId}', surveyId.toString()).replace('{audienceId}', audienceId.toString());

	return url;
}

export async function getParticipationCountsForAudience(surveyId: number, audienceId: number): Promise<IParticipationCountsVm> {
	const url = getAudienceQuery(surveyId, audienceId) + Constants.AUDIENCE_PARTICIPATION_COUNTS_API_URL;
	const res = await axios.get(url);
	return { ...res.data, generationDate: new Date(res.data.generationDate) };
}
